import React from 'react';
import { BiSolidReport } from "react-icons/bi";
import { BsFillCalendar2CheckFill } from 'react-icons/bs';
import { TbCalendarStar } from "react-icons/tb";
import { MdCalendarMonth } from "react-icons/md";
import { NavLink } from 'react-router-dom'; // Import NavLink
import './layout.css'; // Make sure this path is correct

const WorkReportLayout = ({ children }) => {

  return (
    <div>
      <h1 className="layouts-title">
        <BiSolidReport  className="leave-policy-icon" />
        Employee Work Report
      </h1>
      <hr />
      <section>
        <div className="nav-container">
          <ul className="nav-list">
            <li className="nav-item">
              <NavLink
                id="today-reports-link"
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                to="/today-reports"
              >
                <TbCalendarStar  className="nav-icon" /> Current Date
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                id="current-month-work-report-link"
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                to="/current-month-work-report"
              >
                <MdCalendarMonth className="nav-icon" /> Current Month Report
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                id="all-work-reports-link"
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                to="/all-work-reports"
              >
                <BsFillCalendar2CheckFill className="nav-icon" /> Employee Work Report
              </NavLink>
            </li>
          </ul>
        </div>
        <div className="content">
          {children}
        </div>
      </section>
    </div>
  );
};

export default WorkReportLayout;
